import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const mercuryContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: z.object({
                /**
                 * Omitted when an accounting firm connects from the
                 * organization view: the connection is created without a
                 * client and its accounts are assigned afterwards.
                 */
                workspaceId: z.string().uuid().optional(),
                authCode: z.string(),
                defaultEntityId: z.number().optional(),
            }),
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
                404: ErrorMessageSchema,
            },
        },
        migrateFromPlaid: {
            method: "POST",
            path: "/migrate-from-plaid",
            body: z.object({
                plaidConnectionId: z.number(),
                authCode: z.string(),
            }),
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
            },
        },
    },
    {
        pathPrefix: "/mercury",
    },
);
